import { Component, computed, input } from '@angular/core';
import { NgStyle } from '@angular/common';
import { AvatarConfig } from 'quest-atlas-angular-components';

@Component({
  selector: 'app-user-avatar',
  imports: [NgStyle],
  templateUrl: './user-avatar.component.html',
  styleUrl: './user-avatar.component.scss'
})
export class UserAvatarComponent {
  avatarConfig = input<AvatarConfig | null | undefined>();
  username = input<string | undefined>('');
  size = input<number>(48);

  nameFirstLetter = computed(() => this.username()?.charAt(0).toUpperCase() || '?');

  backgroundImage = computed(() => {
    const src = this.avatarConfig()?.src;
    return src ? `url("${src}")` : '';
  });
}
